import React, { useReducer } from "react";
import { OktaAuth } from "@okta/okta-auth-js";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

import { makeStyles } from "@material-ui/core/styles";
import Toaster from "../common/Toaster.jsx";
import "./Login.css";
import { Form } from "../../components/common/ReactHookForm/Form";
import { Input } from "../../components/common/ReactHookForm/Input";
import { useOktaAuth } from '@okta/okta-react';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 2)
  }
}));

const initialState = {
  error: '',
  key: 0,
  sessionToken: false
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUCCESS':
      return {
        ...state,
        error: '',
        key: 0,
        sessionToken: action.payload
      }
    case 'FAILURE':
      return {
        ...state,
        error: "Invalid.login",
        key: crypto.randomUUID(),
        sessionToken: false
      }
    case 'ERROR':
      return {
        ...state,
        error: action.payload,
        key: crypto.randomUUID(),
        sessionToken: false
      }

    default:
      return state
  }
}


const schema = yup.object().shape({
  username: yup.string().required("User Name Required"),
  password: yup.string().required("Password is required")
});

const LoginForm = (props) => {

  const { oktaAuth: authClient } = useOktaAuth();
  const [state, dispatch] = useReducer(reducer, initialState);
  const { error } = state;
  const resolver = yupResolver(schema);
  const { issuer } = props;
  const styles = useStyles();

  const { register, handleSubmit, formState: { errors } } = useForm({
    criteriaMode: "all",
    resolver
  });

  const onSubmit = (data, e) => {
    e.preventDefault();
    const oktaAuth = new OktaAuth({ issuer: issuer });
    oktaAuth.signInWithCredentials({ username: data.username, password: data.password })
      .then(res => {
        if (res && res.status && res.status === "SUCCESS") {
          const sessionToken = res.sessionToken;
          //    authState.isAuthenticated = true;
          dispatch({ type: 'SUCCESS', payload: res.sessionToken });
          //oktaAuth.handleLoginRedirect({ sessionToken });
          //oktaAuth.signInWithRedirect({ sessionToken });
          authClient.signInWithRedirect({ sessionToken });
        } else {

          dispatch({ type: 'FAILURE' });
        }
      })
      .catch(err => {
        dispatch({ type: 'ERROR', payload: err?.errorSummary });
      });

  }

  if (state.sessionToken) {
    return null;
  }



  return (
    <div id="login">
      <h3 className="font-bold text-green-600">
        Login
      </h3>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="col-span-1">
            <div className="mb-4">
              <Input {...register("username")}
                type="text"
                name="username"
                className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.username ? 'border-red-500' : ''}`}
                placeholder="Username" />
              {errors?.username && (
                <p className="text-red-500 text-xs italic">{errors?.username?.message}</p>
              )}
            </div>

            <div className="mb-6">
              <Input {...register("password")}
                type="password"
                name="password"
                className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline ${errors.password ? 'border-red-500' : ''}`}
                placeholder="Password" />
              {(errors?.password || error) && (
                <p className="text-red-500 text-xs italic">{errors?.password?.message || error}</p>
              )}
            </div>

            <button type="submit"
              className="bg-green-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              name="submit">
              Login
            </button>
          </div>
        </div>
      </Form>

      <div>&nbsp;</div>

      {state.error && (
        <Toaster
          text={state.error}
          key={state.key}
          autoHideDuration={3000}
          type="error"
        />
      )}
    </div>
  );
};

export default LoginForm;


